import React, {Component, Fragment} from 'react';

import IconBox from 'lib/struct/icon/IconBox';
import SpanLink from 'lib/control/SpanLink';
import Status from 'lib/control/Status';

import styles from './SaveButton.less';
import Iconui from "../iconui/Iconui";

const {
	'save-button': save_button_class,
	'save-button__col': col_class,
	'save-button__col_status': col_status_class,
} = styles;

export default class SaveButton extends Component {
	render() {
		const {status, onSaveClick, onCancelClick, error} = this.props;
		let error_message = error ? error : 'Ошибка';

		return (
			<span className={save_button_class}>
				<span className={col_class}>
					<button className="button green custom-mr-8" onClick={() => onSaveClick()}
						disabled={status === Status.LOADING}>
						Сохранить
					</button>

					{
						onCancelClick && status === Status.NONE ? (
							<Fragment> или <SpanLink onClick={() => onCancelClick()}>отменить</SpanLink></Fragment>
						) : (null)
					}
				</span>
				<span className={[col_class, col_status_class].join(' ')}>
					{status === Status.LOADING && (
						<IconBox icon={<Iconui name="loading" />}>Загрузка</IconBox>
					)}
					{status === Status.SUCCESS && (
						<IconBox icon={<Iconui name="yes" />}>Сохранено</IconBox>
					)}
					{status === Status.ERROR && (
						<IconBox icon={<Iconui name="cross" />}>{error_message}</IconBox>
					)}
				</span>
			</span>
		);
	}
}
